export class ActionLock {
    inFlight = false;
    listeners = new Set();
    get locked() {
        return this.inFlight;
    }
    subscribe = (listener) => {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    };
    notify() {
        for (const l of this.listeners)
            l();
    }
    /**
     * Run fn under the lock. Returns true if fn was started, false if the
     * call was dropped because something is already in flight. Errors are
     * routed to onError (never rethrown into the press handler); at most one
     * can be in flight, so onError sees at most one failure per settle.
     */
    run(fn, onError) {
        if (this.inFlight)
            return false;
        this.inFlight = true;
        this.notify();
        void (async () => {
            try {
                await fn();
            }
            catch (err) {
                onError?.(err);
            }
            finally {
                this.inFlight = false;
                this.notify();
            }
        })();
        return true;
    }
}
/**
 * Idempotency-key holder. The key identifies an ACTION INSTANCE, not a tap:
 * it is minted once, reused across retries and double-fires (that reuse is
 * what lets the server no-op replays), and rotated only when the action
 * succeeds and the UI moves to a new state.
 */
export class IdemKey {
    mint;
    current;
    constructor(mint = defaultMint) {
        this.mint = mint;
        this.current = this.mint();
    }
    get key() {
        return this.current;
    }
    /** Call on success (or when the target resource changes state). */
    rotate() {
        this.current = this.mint();
        return this.current;
    }
}
function defaultMint() {
    const cryptoObj = globalThis.crypto;
    if (cryptoObj?.randomUUID)
        return cryptoObj.randomUUID();
    // RN Hermes without randomUUID: 128 bits from getRandomValues or Math.random.
    const bytes = new Uint8Array(16);
    if (cryptoObj?.getRandomValues) {
        cryptoObj.getRandomValues(bytes);
    }
    else {
        for (let i = 0; i < 16; i++)
            bytes[i] = Math.floor(Math.random() * 256);
    }
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
//# sourceMappingURL=core.js.map